/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LtiGradeLaunchToSubmissionEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('LTI_GRADE_LAUNCH_TO_SUBMISSION_ENABLED'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class LtiGradeLaunchToSubmissionEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LtiGradeLaunchToSubmissionEnabledSettingParser.decode(input).map(res => new LtiGradeLaunchToSubmissionEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return LtiGradeLaunchToSubmissionEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LtiGradeLaunchToSubmissionEnabledSettingParser.encode(data);
    }
    static schema() {
        return LtiGradeLaunchToSubmissionEnabledSettingParser.schema();
    }
}
